export { default } from './RatingSegmentItem';
